angular.module('picmonicng').controller('ProfileHeaderController', [
  '$scope',
  '$state',
  '$stateParams',
  'UserService',
  'Upload',
  'ngBowser',
  function ($scope, $state, $stateParams, UserService, Upload, ngBowser) {
    $scope.mobileDeviceDetected = ngBowser.isMobile();
    $scope.obj = {};

    $scope.user = UserService.user;

    $scope.uploadPhoto = function (file) {
      if (typeof file !== 'undefined') {
        $scope.uploadingAvatar = true;
        Upload.upload({
          url: 'api/v2/profile/upload_avatar',
          fields: {},
          file: file,
        }).then(
          function (data) {
            UserService.user.avatar = '';
            UserService.user.uploaded_avatar = data.data;
            $scope.uploadingAvatar = false;
          },
          function () {
            $scope.uploadingAvatar = false;
          }
        );
      }
    };

    $scope.$watch('file', function () {
      if ($scope.file != null) {
        $scope.uploadPhoto($scope.file);
      }
    });

    $scope.$watch(
      function () {
        return $scope.obj.mobileUpload;
      },
      function (newVal, oldVal) {
        if (newVal !== oldVal) {
          $scope.file = $scope.obj.mobileUpload;
        }
      }
    );

    $scope.useGravatarAvatar = function () {
      $scope.user.use_gravatar = 1;
      $scope.user.$update();
    };

    $scope.removeAvatar = function () {
      $scope.user.remove_avatar = 1;
      $scope.user.$update();
    };
  },
]);
